module.exports = __webpack_public_path__ + "img/16_28.b393cd5d.png";